// eslint-disable-next-line simple-import-sort/imports
import React, { useState } from 'react'
import { useSelector, useDispatch } from 'react-redux';
// eslint-disable-next-line no-unused-vars
import { hot } from 'react-hot-loader';

import { useParams } from 'react-router-dom';

import BaseButton from '../../../../components/BaseButton';
import BreadCrumb from '../../../../components/BreadCrumb';
import Container from '../../../../components/Container';
import PageTitle from '../../../../components/PageTitle';
import TitleBar from '../../../../components/TitleBar';

import FileDetail from './components/FileDetail';

import { experimentRootUrl, fiscalYearExperimentsUrl, fiscalYearsUrl, folderContentsUrl, downloadUrl } from '../../urls';
import { retrieveFileInfo, retrieveExperiment } from '../../../../sdk/apis';
import { addFolder, loadFolder } from '../../slice';
import { fisYear2Year } from '../FiscalYears/components/FiscalYearList';

const FileInformation = () => {
  // useParamsを用いてurlsから変数を取得
  const { year, ex_id, f_id } = useParams();
  const fiscalYear = parseInt(year);
  const experimentId = parseInt(ex_id);
  const fileId = parseInt(f_id);

  // useStateの作成
  const [experimentInfo, setExperimentInfo] = useState(null);
  const [fileInfo, setFileInfo] = useState(null);

  const folders = useSelector((state) => state.viewer.folders);
  const dispatch = useDispatch();

  // 実験名の取得
  if (experimentInfo === null) {
    retrieveExperiment(experimentId).then((data) => {
      setExperimentInfo(data);
    });

    return null;
  };

  // フォルダ情報の取得
  if (fileInfo === null) {
    retrieveFileInfo(fileId).then((data) => {
      setFileInfo(data);
      addFolder(data);
    });

    return null;
  }

  // パンくずリスト
  const breadcrumbData = [];
  breadcrumbData.push({ title: '実験一覧', url: fiscalYearsUrl(year) });
  breadcrumbData.push({ title: fisYear2Year(fiscalYear), url: fiscalYearExperimentsUrl(year, ex_id) });
  breadcrumbData.push({ title: experimentInfo.caption, url: experimentRootUrl(year, ex_id, f_id) });

  let f = fileInfo;
  const fData = [];
  fData.push(f);
  while (f.parent_id !== null) {
    if (f.parent_id in folders) {
      f = folders[f.parent_id];
      fData.splice(0, 0, f)
    } else {
      dispatch(loadFolder(f.parent_id));
      return null;
    }
  }
  for (let i = 0; i < fData.length; ++i) {
    const f = fData[i];
    if (i === fData.length - 1) {
      breadcrumbData.push({ title: f.name });
    } else {
      breadcrumbData.push({ title: f.name, url: folderContentsUrl(year, ex_id, f.id) });
    }
  }

  // オブジェクト→配列
  const fileInfoArray = Object.entries(fileInfo)

  return (
    <>
      <TitleBar />
      <Container>
        <BreadCrumb data={breadcrumbData} />
        <PageTitle>詳細情報: {fileInfo.name}</PageTitle>

        <FileDetail details={fileInfoArray} />

        <div className='button'>
          <BaseButton onClick={() => {
            document.location = downloadUrl([fileId.toString()]);
          }}>ダウンロード
          </BaseButton>
        </div>

      </Container>
    </>
  );
};

export default FileInformation;
